define.alias("shared/components/shared/carousel/controls", "settings/components/shared/carousel/controls");